import { isValidElement, type ReactElement } from "react";

import cn from "../../utils/cn.util";
import { Badge } from "../badge";
import { type SvgIcon } from "../icons/type";

export type CardTitleProps = {
  children?: React.ReactNode;
  className?: string;
  icon?: SvgIcon | ReactElement;
  subTitle?: string;
  badge?: string | number;
};

export const Title = ({ children, className, subTitle, badge, icon: Icon }: CardTitleProps) => {
  const isSvgIcon = typeof Icon === "function";
  const isReactElement = isValidElement(Icon);

  return (
    <div className="flex flex-col items-start justify-center gap-1">
      <div className="flex items-center gap-2">
        {isSvgIcon && <Icon className="h-5 w-5 shrink-0 text-neutral-70" />}
        {isReactElement && Icon}
        <h2 className={cn("text-base leading-5 font-semibold text-neutral-10", className)}>{children}</h2>
        {badge !== undefined && (
          <Badge.Root size="sm" shape="rounded" variant="light-primary">
            <Badge.Label>{badge}</Badge.Label>
          </Badge.Root>
        )}
      </div>
      {subTitle && <h3 className={cn("ml-7 line-clamp-1 text-sm font-normal text-neutral-variant-40")}>{subTitle}</h3>}
    </div>
  );
};
